import { Icon, IconSize } from '@ardoq/icons';
import { FlexBox } from '@ardoq/layout';
import { PlainTextPopover, WithUncontrolledPopover } from '@ardoq/popovers';
import type { IHeaderParams } from 'ag-grid-community';
import styled from 'styled-components';
import type { ColumnHeaderIcon } from './types';

const HeaderLabel = styled.span.attrs({ className: 'ag-header-cell-text' })`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const IconWrapper = styled.span`
  display: flex;
`;

export type ColumnHeaderWithIconParams = IHeaderParams & {
  headerIcon: ColumnHeaderIcon;
};

export const ColumnHeaderWithIcon = ({
  displayName,
  headerIcon,
}: ColumnHeaderWithIconParams) => (
  <FlexBox align="center" gap="xsmall" minWidth="0">
    <HeaderLabel>{displayName}</HeaderLabel>
    <WithUncontrolledPopover
      content={<PlainTextPopover>{headerIcon.tooltip}</PlainTextPopover>}
    >
      <IconWrapper role="img" aria-label={headerIcon.tooltip}>
        <Icon
          iconName={headerIcon.name}
          iconSize={IconSize.MEDIUM}
          color={headerIcon.color}
        />
      </IconWrapper>
    </WithUncontrolledPopover>
  </FlexBox>
);
